<template>
  <div>
    <div style="margin-top: 20px; font-size: 26px; font-weight: bold">物流轨迹查阅</div>
    <div style="margin-top: 20px">
      <!-- <el-input
        v-model="shipperCode"
        placeholder="快递编码"
        style="width: 300px"
        class="filter-item"
        clearable
      /> -->
      <el-select
        v-model="shipperCode"
        class="filter-item"
        filterable
        placeholder="快递编码"
        clearable
      >
        <el-option
          v-for="(item, index) in kuaidiList"
          :key="index"
          :label="item.name"
          :value="item.code"
          >{{ item.name }}</el-option
        >
      </el-select>
      <el-input
        v-model="expressNo"
        placeholder="快递单号"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="customerName"
        placeholder="手机号后四位"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="sendCity"
        placeholder="发货城市"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-date-picker
        v-model="created_at"
        type="datetime"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="订单创建时间"
      ></el-date-picker>
      <el-button v-waves class="filter-item" type="primary" @click="queryPushTracking">
        查询
      </el-button>
      <br /><br />
      <span style="color: red">{{ errorCommitResult }}</span>
      <br /><br />

      <el-table
        key="0"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        :row-style="{ height: '0' }"
        :cell-style="{ padding: '6px 0' }"
      >
        <el-table-column label="AcceptStation" width="800px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AcceptStation }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Action" width="110px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.Action }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Location" width="140px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.Location }}</span>
          </template>
        </el-table-column>
        <el-table-column label="NEWAcceptStation" width="500px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.NEWAcceptStation }}</span>
          </template>
        </el-table-column>
        <el-table-column label="type" width="160px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.Parsed.type }}</span>
          </template>
        </el-table-column>
        <el-table-column label="AcceptTime" width="200px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AcceptTime }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import waves from "@/directive/waves"; // waves directive

export default {
  name: "queryPushTracking",
  directives: { waves },
  data() {
    return {
      shipperCode: "",
      expressNo: "",
      customerName: "",
      sendCity: "",
      created_at: "",
      commitResult: "",
      errorCommitResult: "",
      list: [],
      kuaidiList: [
        { code: "STO", name: "申通" },
        { code: "YD", name: "韵达" },
        { code: "YTO", name: "圆通" },
        { code: "YZPY", name: "邮政" },
        { code: "ZTO", name: "中通" },
        { code: "DBL", name: "德邦物流" },
        { code: "EMS", name: "EMS" },
        { code: "JD", name: "京东" },
        { code: "JTSD", name: "极兔速递" },
        { code: "SF", name: "顺丰" },
      ],
    };
  },
  methods: {
    queryPushTracking() {
      let alertMsg = "";
      if (
        this.shipperCode == "" ||
        this.shipperCode == null ||
        this.shipperCode == "null"
      ) {
        alertMsg = alertMsg + "快递编码不能为空！请选择正确快递编码;\n";
      }
      if (this.expressNo == "" || this.expressNo == null || this.expressNo == "null") {
        alertMsg = alertMsg + "快递单号时间不能为空！请填写正确快递单号；\n";
      }
      if (this.sendCity == "" || this.sendCity == null || this.sendCity == "null") {
        alertMsg = alertMsg + "发货城市不能为空！请填写正确发货城市;\n";
      }
      if (this.created_at == "" || this.created_at == null || this.created_at == "null") {
        alertMsg = alertMsg + "订单创建时间不能为空！请填写正确订单创建时间。";
      }
      if (alertMsg != "") {
        alert(alertMsg);
        return;
      }
      this.commitResult = "";
      this.errorCommitResult = "";
      this.list = [];
      const url =
        this.$root.ycApiUrl + "api/express/query-push-tracking?trackingNo=1&shipperCode=" +
        this.shipperCode +
        "&expressNo=" +
        this.expressNo +
        "&customerName=" +
        this.customerName +
        "&sendCity=" +
        this.sendCity +
        "&created_at=" +
        this.created_at;
      const res = axios.post(url);
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == 201) {
            this.errorCommitResult = resd.message;
          }
          if (resd && resd.hasOwnProperty("data")) {
            this.list = resd.data.Traces;
          } else {
            this.list = resd.Traces;
          }

          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/secondGenerationLogistics/queryPushTracking.vue